import * as React from 'react';
import { connect } from 'react-redux';
import { getColors } from 'store/settings/selectors';
import { RootAppState } from 'store/types';
import { getCorrectlyAnsweredQuestionsCount } from 'store/sections/selectors';
import NavigationBlock from '../NavigationBlock/NavigationBlock';
import NavigationItem from '../NavigationItem/NavigationItem';

type CollapsedTocPoolSectionProps = {
  questionsForPool?: any;
  colors: { [key: string]: any };
  navigateToQuestion: any;
  activeQuestionId: string;
  activeQuestionIndex: number;
  correctlyAnsweredQuestionsCount?: number;
  isAttemptSubmitted: boolean;
  isSubmitAtOnce: boolean;
  hasGuidedReattempt: boolean;
};

class CollapsedTocPoolSection extends React.Component<CollapsedTocPoolSectionProps> {
  render() {
    const {
      questionsForPool,
      navigateToQuestion,
      activeQuestionId,
      activeQuestionIndex,
      isAttemptSubmitted,
      isSubmitAtOnce,
      hasGuidedReattempt
    } = this.props;

    return (
      <NavigationBlock
        activeItemIndex={activeQuestionIndex}
        navigationElementsCount={questionsForPool.length}
        role="menu"
      >
        {questionsForPool.map((item: any, itemIndex: any) => (
          <NavigationItem
            key={itemIndex}
            role="menuitem"
            tabIndex={0}
            question={item}
            shouldSubmitAllQuestions={isSubmitAtOnce}
            isAttemptSubmitted={isAttemptSubmitted}
            hasGuidedReattempt={hasGuidedReattempt}
            isActive={item.id === activeQuestionId}
            {...(item.id !== activeQuestionId && {
              onClick: () => navigateToQuestion(item.sectionId, item.id),
              onKeyDown: event => {
                if (event.key === 'Enter') {
                  navigateToQuestion(item.sectionId, item.id);
                }
              }
            })}
          />
        ))}
      </NavigationBlock>
    );
  }
}

function mapStateToProps(state: RootAppState) {
  return {
    colors: getColors(state),
    correctlyAnsweredQuestionsCount: getCorrectlyAnsweredQuestionsCount(state)
  };
}

export default connect(mapStateToProps)(CollapsedTocPoolSection);
